import axios from "axios";
import { API_URL, getAuthHeader, getPDFAuthHeader } from ".";
import { ResponseModel } from "../Models/ResponseModel";
import { User } from "../Models/User";
import { Member } from "../Models/Member";
import { ResetPasswordRequest } from "../Models/ResetPasswordRequest";
import { UserClockIn } from "../Models/UserClockIn";
import { BasicSearchRequest } from "../Models/BasicSearchRequest";

class UserApi {
  static getUser(id: string) {
    return axios.get<User>(`${API_URL}/api/user/${id}`, getAuthHeader());
  }
  static addUpdateUser(request: User) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/user`,
      request,
      getAuthHeader()
    );
  }
  static uploadUserImage(request: FormData) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/user/imageupload`,
      request,
      getAuthHeader()
    );
  }
  static getUserFavoritesMembers() {
    return axios.get<Member[]>(
      `${API_URL}/api/user/getUserFavoritesMembers`,
      getAuthHeader()
    );
  }
  static getUserFavoritesUsers() {
    return axios.get<User[]>(
      `${API_URL}/api/user/getUserFavoritesUsers`,
      getAuthHeader()
    );
  }
  static getUserList() {
    return axios.get<User[]>(`${API_URL}/api/user`, getAuthHeader());
  }
  static deleteUser(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/user/${id}`,
      getAuthHeader()
    );
  }
  static updatePassword(userId: number, request: ResetPasswordRequest) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/user/updatepassword/${userId}`,
      request,
      getAuthHeader()
    );
  }
  static getLatestUserClockIn(id: number) {
    return axios.get<UserClockIn>(
      `${API_URL}/api/user/${id}/clockin`,
      getAuthHeader()
    );
  }
  static userClockInOut(id: number) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/user/${id}/clockin`,
      null,
      getAuthHeader()
    );
  }
  static getTodaysRoute(userId: number) {
    return axios.get(
      `${API_URL}/api/user/${userId}/todaysroute`,
      getPDFAuthHeader()
    );
  }
  static getUserClockInList(request: BasicSearchRequest, userId?: number) {
    const params = userId ? { userId } : {};
    return axios.post<UserClockIn[]>(
      `${API_URL}/api/user/clockin/list`,
      request,
      { ...getAuthHeader(), params }
    );
  }
  static getUserClockIn(id: number) {
    return axios.get<UserClockIn>(
      `${API_URL}/api/user/clockin/${id}`,
      getAuthHeader()
    );
  }
  static addUpdateUserClockIn(request: UserClockIn) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/user/clockin`,
      request,
      getAuthHeader()
    );
  }
}

export default UserApi;
